import { Box, Divider } from '@mui/material'
import React, { memo } from 'react'
import { useStyles } from './styles'
import AlertsHeader from './alertsHeader/AlertsHeader'
import AlertsTabView from './alertsTabView/alertsTabView'

const Alerts = () => {
    const { classes } = useStyles()
    return (
        <Box className={classes.alertContainer}>
            <AlertsHeader />
            <Divider />
            <AlertsTabView />
        </Box>
    )
}

export default memo(Alerts)
